module.exports = __webpack_public_path__ + "media/src/public/img/payment/yandex-logo-min-cccdacf4050d20f508f2fc4d19b97c3f.svg";